import React, { ReactNode, useEffect } from "react";
import { Box } from "@mui/material";

interface PrintableContainerProps {
  id: string;
  children: ReactNode;
  className?: string;
  showInView?: boolean;
  reloadAfterPrint?: boolean; // optional prop to control reload
}

const PrintableContainer: React.FC<PrintableContainerProps> = ({
  id,
  children,
  className = "",
  showInView = true,
  reloadAfterPrint = true, // default true
}) => {
  useEffect(() => {
    // Inject print styles
    const printStyles = `
      @media print {
        .no-print {
          display: none !important;
        }
        .print-only {
          display: block !important;
        }
        .truncate-description {
          white-space: normal !important;
          overflow: visible !important;
          text-overflow: unset !important;
        }
        #${id} {
          width: 100% !important;
          padding: 0 !important;
          margin: 0 !important;
        }
      }
    `;

    const styleTag = document.createElement("style");
    styleTag.innerHTML = printStyles;
    document.head.appendChild(styleTag);

    return () => {
      document.head.removeChild(styleTag);
    };
  }, [id]);

  useEffect(() => {
    if (!reloadAfterPrint) return;

    const handleAfterPrint = () => {
      // Reload page after print or cancel
      window.location.reload();
    };

    window.addEventListener("afterprint", handleAfterPrint);
    return () => window.removeEventListener("afterprint", handleAfterPrint);
  }, [reloadAfterPrint]);

  return (
    <Box
      id={id}
      className={`printable-content ${className}`}
      sx={showInView ? {} : { display: "none" }}
    >
      {children}
    </Box>
  );
};

export default PrintableContainer;
